import { atom } from 'recoil'
import { IdToken } from '@auth0/auth0-react'

export const tokenState = atom<IdToken | null>({
  key: 'tokenState',
  default: null,
})
